const ClientTableSkeleton = () => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <tr key={index}>
          <td>
            <div
              className="skeleton-box"
              style={{ width: "20px", height: "14px" }}
            />
          </td>
          <td>
            <div
              className="skeleton-box"
              style={{ width: "150px", height: "14px" }}
            />
          </td>
          <td>
            <div
              className="skeleton-box"
              style={{ width: "180px", height: "14px" }}
            />
          </td>
          <td>
            <div
              className="skeleton-box"
              style={{ width: "160px", height: "14px" }}
            />
          </td>
          <td>
            <div
              className="skeleton-box"
              style={{ width: "150px", height: "14px" }}
            />
          </td>
        </tr>
      ))}
    </>
  );
};
export default ClientTableSkeleton;
